import { useTheme } from "next-themes";
import { Toaster as Sonner, toast } from "sonner";

type ToasterProps = React.ComponentProps<typeof Sonner>;

const Toaster = ({ ...props }: ToasterProps) => {
  const { theme = "system" } = useTheme();

  return (
    <Sonner
      theme={theme as ToasterProps["theme"]}
      className="toaster group"
      closeButton={true}
      position="top-center"
      toastOptions={{
        classNames: {
          toast:
            "group toast group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg",
          description: "group-[.toast]:text-muted-foreground",
          actionButton: "group-[.toast]:bg-primary group-[.toast]:text-primary-foreground",
          cancelButton: "group-[.toast]:bg-muted group-[.toast]:text-muted-foreground",
          closeButton: "group-[.toast]:!bg-transparent group-[.toast]:!text-foreground group-[.toast]:!border-0 group-[.toast]:hover:!bg-foreground/10 group-[.toast]:!opacity-100 !absolute !right-2 !top-2 !min-h-[44px] !min-w-[44px] !flex !items-center !justify-center !cursor-pointer !pointer-events-auto",
        },
      }}
      {...props}
    />
  );
};

export { Toaster, toast };
